import React, { useState } from "react";

const CopyLink = ({ linkUrl = "Please add link" }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = (linkUrl) => {
    navigator.clipboard.writeText(linkUrl);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <div
      className="d-flex align-items-center"
      style={{
        width: "100%",
        border: "1px solid #e5e5e5",
        borderRadius: "5px",
        padding: "5px 10px",
        height: "40px",
      }}
    >
      <div className="flex-grow-1">{linkUrl}</div>
      {!isCopied && (
        <span
          className="d-flex align-items-center gap-1 cursor-pointer"
          onClick={() => copyToClipboard(linkUrl)}
        >
          <i className=" ri-link-m fs-4"></i> <span>Copy</span>
        </span>
      )}
      {isCopied && <span className="text-success">Copied</span>}
    </div>
  );
};

export default CopyLink;
